import { Helmet } from 'react-helmet-async';
import { Container,Typography } from '@mui/material';
import { DashboardView } from '../sections/@dashboard/app';

// ----------------------------------------------------------------------

export default function DashboardPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard | InnoWave API Hub </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h3" gutterBottom>
          Hi, Welcome To InnoWave API Hub
        </Typography>
        <DashboardView />
      </Container>
    </>
  );
}
